// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes fade{0%{opacity:1}50%{opacity:.4}to{opacity:1}}@keyframes fade{0%{opacity:1}50%{opacity:.4}to{opacity:1}}.content-8 /deep/ .luzhutable__content__item:first-child .textbox__item:last-child .textbox__item__text{font-size:14PX;height:1.44928rem;-webkit-animation:fade .6s infinite;animation:fade .6s infinite}", ""]);
// Exports
module.exports = exports;
